/**
 * 【消息列表】
 */
import React from 'react';
import OrderTable from './components/OrderTable';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { XOKButton, XSelect, XCancelButton, XDatePicker, XInput, XTabNav, showConfirm } from '@/components/xqxc_ui';
import http from '@/assets/api/http';
import { message } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { SearchBox, SearchItem } from '@/components/Layout';
import { addOneBreadcrumbPath, keepSecondNavBreadcrumb } from '@/reducers/home/actions';
import model from '@/reducers/client/messageMove/model';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';

class Main extends React.Component {
    state = {
        tab: [
            { id: 1, label: '消息列表' },
            // { id: 2, label: '已读' },
        ],
        curTabID: 1,  // 当前显示的Tab页ID
        orderID: '', // 当前操作的订单ID 
        systemType: {},
        messageState: {},
        pushTimeStart: null,
        pushTimeEnd: null,
        messageTitle: '',
        pageNum: 1,
        pageSize: 10,
    }

    componentDidMount() {
        this.props.getSystemTypeEnum({ enumName: 'SystemTypeEnum' });
        this.props.getMessageStateEnum({ enumName: 'MessageStateEnum' });
    }

    // Tab页切换
    _tabChangeHandle = (tabID) => {
        this.setState({ curTabID: tabID });
    }
    // 查询
    _searchHandle = (useCache) => {
        const { systemType, messageState, pushTimeStart, pushTimeEnd, messageTitle, pageNum, pageSize } = this.state;
        this.searchCache = {
            systemType: systemType.code,
            messageState: messageState.code,
            messageTitle,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pushTimeStart,
            pushTimeEnd,
        };
        this.props.getlistMessageInfo(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }
    // 重置
    _resetHandle = () => {
        this.setState({
            systemType: {},
            messageState: {},
            pushTimeStart: null,
            pushTimeEnd: null,
            messageTitle: '',
            pageNum: 1,
            pageSize: 10,
        }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }
    // 表格操作
    _tableAction = (id, type) => {
        const { history, addOneBreadcrumbPath } = this.props;
        switch (type) {
            case 'open':
                showConfirm('是否确定开启？', '', () => {
                    http('/?cmd=com.xqxc.api.pig.mis.biz.platform.MessageInfoMisService.openMessageInfo', { id }, 'POST')
                        .then(() => {
                            message.success('开启成功!');
                            this._searchHandle('useCache');
                        }).catch((reject) => {
                            message.error(reject.message);
                        });
                });
                break;
            case 'close':
                showConfirm('是否确定关闭？', '', () => {
                    http('/?cmd=com.xqxc.api.pig.mis.biz.platform.MessageInfoMisService.colseMessageInfo', { id }, 'POST')
                        .then(() => {
                            message.success('关闭成功!');
                            this._searchHandle('useCache');
                        }).catch((reject) => {
                            message.error(reject.message);
                        });
                });
                break;
            case 'info':
                addOneBreadcrumbPath({
                    title: '消息详情',
                    path: `/home/client/messageMove/detail/${id}`
                });
                history.push({
                    pathname: `/home/client/messageMove/detail/${id}`
                });
                break;
            case 'edit':
                addOneBreadcrumbPath({
                    title: '编辑消息',
                    path: `/home/client/messageMove/edit/${id}`
                });
                history.push({
                    pathname: `/home/client/messageMove/edit/${id}`
                });
                break;
            case 'delete':
                showConfirm('是否确定删除？', '', () => {
                    http('/?cmd=com.xqxc.api.pig.mis.biz.platform.MessageInfoMisService.delMessageInfo', { id }, 'POST')
                        .then(() => {
                            message.success('删除成功!');
                            this._searchHandle('useCache');
                        }).catch((reject) => {
                            message.error(reject.message);
                        });
                });
                break;
        }
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({
            pageSize,
            pageNum,
        }, () => {
            this._searchHandle('useCache');
        });
    }
    // 新建
    _newHandle = () => {
        const { history, addOneBreadcrumbPath } = this.props;
        addOneBreadcrumbPath({
            title: '新建消息',
            path: '/home/client/messageMove/add'
        });
        history.push({
            pathname: '/home/client/messageMove/add'
        });
    }
    startDate = () => {
        this.setState({pushTimeEnd: undefined });
    }
    disabledDate = (current) => {
        const { pushTimeStart } = this.state;
        let enddays = pushTimeStart && moment(pushTimeStart);
        return current && current < enddays && enddays.startOf('day');
    }
    render() {
        const { curTabID, messageTitle, pushTimeEnd, pushTimeStart, systemType, messageState } = this.state;
        const { listMessageInfo, SystemTypeEnum, MessageStateEnum } = this.props;
        const SystemTypeEnumValue = SystemTypeEnum.filter(i => (i.code !== "MERCHANT_APP" && i.code !== "OPERATION_COMPANY"));
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    {/* <XTabNav renderData={this.state.tab} onChange={this._tabChangeHandle} activedID={this.state.curTabID} /> */}
                    <div style={{ marginBottom: 10 }}>
                        <SearchBox>
                            <SearchItem>
                                <XInput
                                    label='消息主题'
                                    placeholder='请输入'
                                    value={messageTitle}
                                    bindThis={this}
                                    bindName='messageTitle'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XSelect
                                    label='推送端口'
                                    placeholder='请选择'
                                    renderData={SystemTypeEnumValue}
                                    // onChange={this._messageTypeChange}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={systemType.value}
                                    bindName='systemType'
                                    bindThis={this}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XSelect
                                    label='状态'
                                    placeholder='请选择'
                                    renderData={MessageStateEnum}
                                    // onChange={this._messageStatusChange}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={messageState.value}
                                    bindName='messageState'
                                    bindThis={this}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XDatePicker
                                    label='推送时间'
                                    value={pushTimeStart}
                                    bindThis={this}
                                    bindName='pushTimeStart'
                                    isFormat
                                    showTime={false}
                                    defaultTime='00:00:00'
                                    onChange={this.startDate}
                                />
                                <XDatePicker
                                    style={{ marginRight: 20 }}
                                    label=''
                                    value={pushTimeEnd}
                                    bindThis={this}
                                    bindName='pushTimeEnd'
                                    isFormat
                                    showTime={false}
                                    defaultTime='23:59:59'
                                    disabledDate={this.disabledDate}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XOKButton
                                    label='查询'
                                    onClick={this._searchHandle}
                                />
                                <XCancelButton
                                    label='重置'
                                    onClick={this._resetHandle}
                                />
                            </SearchItem>
                        </SearchBox>
                    </div>
                    <XOKButton
                        style={{ width: 90 }}
                        label='新建消息'
                        onClick={this._newHandle}
                    />
                    <OrderTable renderData={listMessageInfo} tableAction={this._tableAction} paginationChange={this._paginationChange} curTabID={curTabID} />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    addOneBreadcrumbPath: PropTypes.func, // 添加一个面包屑导航子级
    keepSecondNavBreadcrumb: PropTypes.func, // 保持两级面包屑导航
    getlistMessageInfo: PropTypes.func,
    listMessageInfo: PropTypes.object,
    getSystemTypeEnum: PropTypes.func,
    SystemTypeEnum: PropTypes.array,
    getMessageStateEnum: PropTypes.func,
    MessageStateEnum: PropTypes.array,
};
const mapStateToProps = (state) => ({
    listMessageInfo: state.messageMove.listMessageInfo,
    SystemTypeEnum: state.messageMove.SystemTypeEnum,
    MessageStateEnum: state.messageMove.MessageStateEnum,
});
export default connect(mapStateToProps, { addOneBreadcrumbPath, keepSecondNavBreadcrumb, ...model.actions })(Main);
